import React, {Suspense} from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import SEO from '../components/SEO/SEO';

const ThreeBackground = React.lazy(() => import('../components/ThreeBackground'));


const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white relative overflow-hidden">
      <div className="absolute inset-0 z-0">
      <SEO 
        title="404 | Mahmudur Rahman | Full Stack Developer"
        description="Full Stack Developer specializing in MERN stack development. Building modern web applications with React, Node.js, and MongoDB."
        image="https://res.cloudinary.com/dqovjmmlx/image/upload/v1740489727/notfound_yfbxbx.jpg"
      />
        {/* 3D Background */}
         <Suspense fallback={<div className="absolute inset-0 z-0 bg-gray-900" />}>
         <div className="absolute inset-0 z-0">
            <ThreeBackground />
           </div>
           </Suspense>
      </div>

      <div className="relative z-10 container mx-auto px-4 h-screen flex flex-col items-center justify-center">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-7xl md:text-9xl font-bold mb-8 glitch"
          style={{ textShadow: '2px 2px 20px rgba(79, 70, 229, 0.5)' }}
        >
          404
        </motion.h1> 
        
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-xl md:text-2xl text-gray-400 mb-12 text-center"
        >
          Oops! The page you're looking for doesn't exist in this dimension.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <Link
            to="/"
            className="flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
          >
            <FaHome />
            <span>Back to Home</span>
          </Link>
        </motion.div>
      </div>

      <style jsx>{`
        .glitch {
          animation: glitch 1s linear infinite;
        }
        
        @keyframes glitch {
          2%, 64% {
            transform: translate(2px, 0) skew(0deg);
          }
          4%, 60% {
            transform: translate(-2px, 0) skew(0deg);
          }
          62% {
            transform: translate(0, 0) skew(5deg);
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;